<div class="div-arriere-plan-action" (click)="onDismiss(true)"></div>
<div class="div-global-action" (click)="$event.stopPropagation()">
  <div id="center-square">
    <div style="display: flex; justify-content: space-between; flex-direction: column; height: 100%">
      <div *ngIf="!isAssessors" class="flex gap-10">
        <img class="close-icon" src="assets/close_cross_black.svg" (click)="onDismiss(true)">
        <h3 class="bold header_title dark-blue">Les options disponibles</h3>
      </div>

      <div class="dark-blue flex flex-column gap-20">
        <div>
          <p>{{'PRICE-DETAILS.SMS-ON-CHANGE' | translate}}</p>
          <vc-sms-details-popup *ngIf="SMSOffers" [isAssoc]="isAssoc" [voters]="voters"
            (selectedOption)="SMSOption($event)" [SMSOwned]="SMSOwned"></vc-sms-details-popup>
        </div>

        <div>
          <p>{{'HOTLINE.HOTLINE-TEXT' | translate}}</p>
          <vc-hotline-details [isAssoc]="isAssoc" (selectedOption)="hotlineOption($event)"
            [licenseTime]="licenseTime"></vc-hotline-details>
        </div>
      </div>

      <div>
        <div style="display: flex; justify-content: space-between; flex-direction: column; align-items: center;">
          <p (click)=onDismiss(false) class="dark-blue pointer" style="margin-bottom: 0px;">Fermer</p>
        </div>
      </div>
    </div>
  </div>
</div>